import { render, staticRenderFns } from "./ReportCategories.vue?vue&type=template&id=2a0db780&scoped=true&"
import script from "./ReportCategories.vue?vue&type=script&lang=js&"
export * from "./ReportCategories.vue?vue&type=script&lang=js&"
import style0 from "./ReportCategories.vue?vue&type=style&index=0&id=2a0db780&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0db780",
  null
  
)

export default component.exports